import { render, staticRenderFns } from "./ClinicDoctors.vue?vue&type=template&id=09d4e094&scoped=true"
import script from "./ClinicDoctors.vue?vue&type=script&lang=js"
export * from "./ClinicDoctors.vue?vue&type=script&lang=js"
import style0 from "./ClinicDoctors.vue?vue&type=style&index=0&id=09d4e094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d4e094",
  null
  
)

export default component.exports